import { useParams, useNavigate, Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Button from '../components/Button'

function CallTheOffice() {
  const [product, setProduct] = useState({})
  const navigate = useNavigate()
  const params = useParams()

  useEffect(() => {
    const fetchSlab = async () => {
      const res = await fetch(`/inventory/${params.id}`)
      const data = await res.json()

      setProduct(data)
    }
    fetchSlab()
  }, [])

  return (
    <div className=''>
      <div className='flex flex-row-reverse md:flex-col justify-between'>
        <div className='pl-2 text-xs md:text-base breadcrumbs pr-2 mt-2 md:pl-6'>
          <ul>
            <li>
              <Link to='/'>Home</Link>
            </li>
            <li>
              <Link to='/inventory'>Inventory</Link>
            </li>
            <li>{product.id}</li>
          </ul>
        </div>
        <div className='flex justify-evenly mt-1 md:justify-start pl-2 md:pl-6'>
          <div
            onClick={() => {
              navigate(-1)
            }}
            className='btn btn-xs btn-outline cursor-pointer text-slate-500 md:text-base text-xs mt-2 md:font-medium md:btn-sm'
          >
            Go Back
          </div>
        </div>
      </div>
      <div className='hero mb-3 bg-white text-slate-600 pb-2'>
        <div className='hero-content text-center p-2'>
          <div className='max-w-md justify-center'>
            <h1 className='text-xl font-bold text-sky-600 md:text-2xl'>
              Call Our Office
            </h1>
            <p className='p-1 text-sm border-b border-b-gray-300 md:text-xl md:p-3'>
              Provide Details Below:
            </p>

            <div className='pb-2 md:pt-2'>
              <figure className='flex justify-center'>
                <img
                  src={product.image}
                  alt=''
                  className='object-cover h-64 md:h-80'
                />
              </figure>
              <ul className='list-disc list-inside text-xs text-left mx-8 md:text-base'>
                <li className='py-1 md:py-2'>ID: {product.id}</li>
                <li className='py-1 md:py-2'>Name: {product.color}</li>
                <li className='py-1 md:py-2'>Brand: {product.brand}</li>
                <li className='py-1 md:py-2'>Thickness: {product.thickness}</li>
                <li className='py-1 md:py-2'>
                  Size: {product.length}" x {product.width}"
                </li>

                <li className='py-1 md:py-2'>Location: {product.location}</li>
                <li className='py-1 md:py-2'>Price: Call and ask for Aldrin</li>
              </ul>
            </div>
            <Button>
              <a href='tel:15104752650'>(510) 475 2650</a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CallTheOffice
